import * as React from 'react'
import { useCallback, useContext } from 'react'
import Clickable from 'components/Common/Clickable'
import InlineIcon from 'components/utils/InlineIcon'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import MaldivesReturnForFreeInfoModal from 'components/MaldivesDirect/MaldivesReturnForFreeInfoModal'
import { FormattedMessage, useIntl } from 'react-intl'

function ReturnFareFreeLabel() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const isLuxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)

  const handleInfoClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<MaldivesReturnForFreeInfoModal />)
  }, [showModal])

  if (!isLuxPlusEnabled) {
    return null
  }

  return (
    <BodyTextBlock
      variant="medium"
      weight="bold"
      colour="lux-plus"
      startIcon={<SolidFireIcon />}
    >
      <FormattedMessage
        id="pIOxPw-SIUKc0IBvXxf6"
        defaultMessage="Return for FREE with LuxPlus+ {infoIcon}"
        description="Promotional callout shown when LuxPlus members get the Maldives charter return economy flight fare for free, followed by an icon opening the explainer"
        values={{
          infoIcon: (
            <Clickable
              onClick={handleInfoClick}
              aria-label={intl.formatMessage({
                id: 'cOz22e4pg-jsCM_tpAzb',
                defaultMessage: 'How the return for free flight sale works',
                description: 'Accessible label for the icon that opens the Maldives return for free campaign explainer',
              })}
            >
              <InlineIcon Icon={LineInfoCircleIcon} colour="normal-contrast" />
            </Clickable>
          ),
        }}
      />
      <CaptionTextBlock variant="medium" weight="normal" colour="neutral-one">
        {intl.formatMessage({
          id: 'RYSN2wnu7sMq1x3SDYey',
          defaultMessage: 'Excludes all domestic connecting flights',
          description: 'Disclaimer under the return for free callout clarifying that the free return flight does not cover domestic connecting flights',
        })}
      </CaptionTextBlock>
    </BodyTextBlock>
  )
}

export default ReturnFareFreeLabel
